import GasoilModal from './GasoilModal';

export default GasoilModal;
